import { useContext } from 'react';

import { AutoWithdrawContext } from './index';

export const useAutoWithdraw = () => {
  const val = useContext(AutoWithdrawContext);

  return val;
};
